import { EnumOption } from "./enum-option";

export const ImmigrantStatus = {
    B1: 0,
    B2: 1,
    DA: 2,
    E1: 3,
    E2: 4,
    E3: 5,
    E3D: 6,
    EADI485: 7,
    F1: 8,
    F1CPT: 9,
    F1OPT: 10,
    F2: 11,
    H1B: 12,
    H1B1: 13,
    H2A: 14,
    H2B: 15,
    H3: 16,
    H4: 17,
    J1ResearchScholar: 18,
    J1Student: 19,
    J1SWT: 20,
    J2: 21,
    K1: 22,
    K2: 23,
    K3: 24,
    K4: 25,
    L1A: 26,
    L1AT: 27,
    L1B: 28,
    L2: 29,
    LPR: 30,
    O1: 31,
    O2: 32,
    O3: 33,
    P1: 34,
    P2: 35,
    P3: 36,
    PR: 37,
    R1: 38,
    R2: 39,
    RP: 40,
    TD: 41,
    TN: 42,
    USC: 43,
    TPS: 44,
    AsylumApplicationPending: 45,
    DACA: 46
};

export const ImmigrantStatusList: EnumOption[] = [
    { value: ImmigrantStatus.B1, label: 'B-1' },
    { value: ImmigrantStatus.B2, label: 'B-2' },
    { value: ImmigrantStatus.DA, label: 'DA' },
    { value: ImmigrantStatus.E1, label: 'E-1' },
    { value: ImmigrantStatus.E2, label: 'E-2' },
    { value: ImmigrantStatus.E3, label: 'E-3' },
    { value: ImmigrantStatus.E3D, label: 'E-3D' },
    { value: ImmigrantStatus.EADI485, label: 'EAD I-485' },
    { value: ImmigrantStatus.F1, label: 'F-1' },
    { value: ImmigrantStatus.F1CPT, label: 'F-1 CPT' },
    { value: ImmigrantStatus.F1OPT, label: 'F-1 OPT' },
    { value: ImmigrantStatus.F2, label: 'F-2' },
    { value: ImmigrantStatus.H1B, label: 'H-1B' },
    { value: ImmigrantStatus.H1B1, label: 'H-1B1' },
    { value: ImmigrantStatus.H2A, label: 'H-2A' },
    { value: ImmigrantStatus.H2B, label: 'H-2B' },
    { value: ImmigrantStatus.H3, label: 'H3' },
    { value: ImmigrantStatus.H4, label: 'H-4' },
    { value: ImmigrantStatus.J1ResearchScholar, label: 'J-1 Research Scholar' },
    { value: ImmigrantStatus.J1Student, label: 'J-1 Student' },
    { value: ImmigrantStatus.J1SWT, label: 'J-1SW/T' },
    { value: ImmigrantStatus.J2, label: 'J-2' },
    { value: ImmigrantStatus.K1, label: 'K-1' },
    { value: ImmigrantStatus.K2, label: 'K-2' },
    { value: ImmigrantStatus.K3, label: 'K-3' },
    { value: ImmigrantStatus.K4, label: 'K-4' },
    { value: ImmigrantStatus.L1A, label: 'L-1A' },
    { value: ImmigrantStatus.L1AT, label: 'L-1AT' },
    { value: ImmigrantStatus.L1B, label: 'L-1B' },
    { value: ImmigrantStatus.L2, label: 'L-2' },
    { value: ImmigrantStatus.LPR, label: 'LPR' },
    { value: ImmigrantStatus.O1, label: 'O-1' },
    { value: ImmigrantStatus.O2, label: 'O-2' },
    { value: ImmigrantStatus.O3, label: 'O-3' },
    { value: ImmigrantStatus.P1, label: 'P-1' },
    { value: ImmigrantStatus.P2, label: 'P-2' },
    { value: ImmigrantStatus.P3, label: 'P-3' },
    { value: ImmigrantStatus.PR, label: 'PR' },
    { value: ImmigrantStatus.R1, label: 'R-1' },
    { value: ImmigrantStatus.R2, label: 'R-2' },
    { value: ImmigrantStatus.RP, label: 'RP' },
    { value: ImmigrantStatus.TD, label: 'TD (spouse/child of TN worker)' },
    { value: ImmigrantStatus.TN, label: 'TN' },
    { value: ImmigrantStatus.USC, label: 'USC' },
    { value: ImmigrantStatus.TPS, label: 'TPS' },
    { value: ImmigrantStatus.AsylumApplicationPending, label: 'Asylum Application Pending' },
    { value: ImmigrantStatus.DACA, label: 'DACA' }
];